import { DashboardLayout } from '../../pages/layouts/DashboardLayout'
import DashboardPage from '../../pages/Dashboard/DashboardPage.jsx'
import { ROUTES } from '../../shared/config/routes'
import { NotFoundPage } from '../../pages/NotFound/NotFoundPage'
import { StudentsPage } from '../../pages/Students/StudentsPage'
import { ProfilePage } from '../../pages/Profile/ProfilePage'
import { LoginPage } from '../../pages/Auth/LoginPage'
import { SettingsPage } from '../../pages/Setting/SettingsPage'
import UserManagementPage from '../../pages/UserManagement/UserManagementPage'
import ParentNotification from '../../pages/Setting/components/ParentNotification/ParentNotification.jsx'
import StudentProfilePage from '../../pages/StudentProfile/StudentProfilePage'
import { SessionsPage } from '../../pages/Sessions/SessionsPage'
import { MessagesPage } from '../../pages/Messages/MessagesPage'
import SsoCallback from '../../pages/SsoCallBack/SsoCallBack.jsx'
import Protected from '../../shared/ui/Protected.jsx'
import AdminRoute from '../../shared/ui/AdminRoute.jsx'
import { ClassroomPage } from 'pages/Classroom/ClassroomPage'
import { ApplicationsPage } from 'pages/ApplicationsPage/ApplicationsPage'
import { ApplicationDetailsPage } from 'pages/ApplicationDetailsPage/ApplicationDetailsPage'
import ResearchPage from 'pages/Research/ResearchPage'
import { ReportsHub } from '../../pages/Reports/ReportsHub'
import { GovernmentReport } from '../../pages/Reports/GovernmentReport/GovernmentReport'
import { StudentReport } from '../../pages/Reports/StudentReport/StudentReport'
import { CounsellorReport } from '../../pages/Reports/CounsellorReport/CounsellorReport'

export const routes = [
	{
		path: '/sso-callback',
		element: <SsoCallback />,
	},
	{
		path: '/auth',
		element: <LoginPage />,
	},
	{
		path: '/',
		element: (
			<Protected>
				<DashboardLayout />
			</Protected>
		),
		children: [
			{
				index: true,
				element: <DashboardPage />,
			},
			{
				path: ROUTES.STUDENTS,
				element: <StudentsPage />,
			},
			{
				path: `${ROUTES.STUDENT_PROFILE}/:studentId`,
				element: <StudentProfilePage />,
			},
			{
				path: ROUTES.SETTINGS,
				element: <SettingsPage />,
			},
			{
				path: ROUTES.USER_MANAGEMENT,
				element: (
					<AdminRoute>
						<UserManagementPage />
					</AdminRoute>
				),
			},
			{
				path: ROUTES.PARENT_NOTIFICATIONS,
				element: <ParentNotification />,
			},
			{
				path: ROUTES.PARENT_COMMUNICATION,
				element: <ParentNotification />,
			},
			{
				path: ROUTES.SESSIONS,
				element: <SessionsPage />,
			},
			{
				path: ROUTES.PROFILE,
				element: <ProfilePage />,
			},
			{
				path: ROUTES.MESSAGES,
				element: <MessagesPage />,
			},
			{
				path: ROUTES.REPORTS,
				element: <ReportsHub />,
			},
			{
				path: `${ROUTES.REPORTS}/compliance/:jurisdictionId`,
				element: <GovernmentReport />,
			},
			{
				path: `${ROUTES.REPORTS}/students`,
				element: <StudentReport />,
			},
			{
				path: `${ROUTES.REPORTS}/workload`,
				element: <CounsellorReport />,
			},
			{
				path: ROUTES.RESEARCH,
				element: <ResearchPage />,
			},
			{
				path: ROUTES.CLASSROOM,
				element: <ClassroomPage />,
			},
			{
				path: ROUTES.APPLICATIONS,
				element: <ApplicationsPage />,
			},
			{
				path: ROUTES.APPLICATION_DETAILS,
				element: <ApplicationDetailsPage />,
			},
			{
				path: '*',
				element: <NotFoundPage />,
			},
		],
	},
]
